import { render } from "./HeaderTitle.vue?vue&type=template&id=59ae6be6"
import script from "./HeaderTitle.vue?vue&type=script&lang=js"
export * from "./HeaderTitle.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__